import { useAdministrationContext } from '@openx/components-administration/lib/utils/context/AdministrationContext';
import { HeaderActions } from '@openx/components-header/HeaderActions/HeaderActions';
import { PageHeader } from '@openx/components-header/PageHeader';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { InventoryListsList } from './components/InventoryLists/InventoryListsList';

export const InventoryListsListPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { useInventoryListsFetch } = useAdministrationContext();
  const { inventoryLists, loading, criteria, setCriteria } = useInventoryListsFetch();

  return (
    <PageHeader
      sticky
      render={() => (
        <HeaderActions
          actions={[
            {
              label: t('Create'),
              onClick: () => {
                navigate('/inventory-lists/create');
              },
              color: 'primary',
              showAsActionButton: true,
              id: 'create-inventory-list-button',
            },
          ]}
        />
      )}
      title={t('Inventory Lists')}
    >
      <InventoryListsList
        setCriteria={setCriteria}
        criteria={criteria}
        inventoryLists={inventoryLists}
        loading={loading}
      />
    </PageHeader>
  );
};
